<template>
  <div class="content_menu clearfix">
    <div class="left" style="width:343px">
      <div class="left" style="width:178px;">
        <TheFoodMenu active="sides" />
      </div>

      <div class="left" style="margin:0px 0 0 27px;">
        <img src="/assets/images/titles/menu_left_sides.png">
      </div>

      <br clear="all" />
    </div>

    <div class="right" style="width:552px; margin:8px 0px 0 0;">
      <div class="left" style="width:522px; height:117px;">
        <img src="/assets/images/menu_img/sides.png" />
      </div>

      <br clear="all" />

      <div class="product-container">
        <ProductList :products="products" />
      </div>

      <div class="menu_right">
        <div class="right" style="margin:-116px 14px 0 0;">
          <img src="/assets/images/menu_img/menu_right_sides.png">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TheFoodMenu from '@/components/TheFoodMenu.vue';
import ProductList from '@/components/ProductList.vue';

export default {
  name: 'Sides',

  components: {
    TheFoodMenu,
    ProductList,
  },

  data() {
    return {
      products: [
        {
          id: 1,
          name: 'FRENCH FRIES',
          description: '',
          modifiers: [],
        },
        {
          id: 2,
          name: 'GARLIC FRIES',
          description: '',
          modifiers: [],
        },
        {
          id: 3,
          name: 'SWEET POTATO FRIES',
          description: '',
          modifiers: [],
        },
        {
          id: 4,
          name: 'CHILI CHEESE FRIES',
          description: '',
          modifiers: [],
        },
        {
          id: 5,
          name: 'ONION RINGS',
          description: '',
          modifiers: [],
        },
        {
          id: 6,
          name: 'HOMEMADE CHILI',
          description: '',
          modifiers: [],
        },
        {
          id: 7,
          name: 'HOMEMADE SOUPS',
          description: '',
          modifiers: [],
        },
      ],
    };
  },
};
</script>
